import React, { useState } from 'react'
import { PublicWrapper } from 'src/components/layout/PublicWrapper'
import { Navigate } from 'react-router-dom'
import { ROUTES } from 'src/constants/routes'
import { useDispatch } from 'react-redux'
import { SignUpForm } from 'src/components/auth/sign-up-form/SignUpForm'
import { SignUpFormValues } from 'src/components/auth/sign-up-form/SignUpForm.interface'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { MCSignUp } from 'src/constants/actionTypes'
import { handleApiError } from 'src/utils/errorHandlers'
import { useQuery } from 'src/utils/hooks/useQuery'

export const MCSignUpPage = () => {
  const dispatch = useDispatch()
  const { getQuery } = useQuery()

  const inviteId = getQuery('inviteId')

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleFormSubmit = async (values: SignUpFormValues) => {
    if (!inviteId) {
      return
    }

    setIsLoading(true)

    try {
      await createAsyncAction(dispatch, MCSignUp.request({ inviteId, ...values }))
    } catch (err: any) {
      handleApiError(err)
    } finally {
      setIsLoading(false)
    }
  }

  if (!inviteId) {
    return <Navigate to={ROUTES.SIGN_IN_URL} />
  }

  return (
    <PublicWrapper>
      <SignUpForm isLoading={isLoading} onSubmit={handleFormSubmit} />
    </PublicWrapper>
  )
}
